module.exports = __webpack_public_path__ + "static/media/webwiz.bafbb927.jpg";